<template>
  <div id="dashboard-metric-trends" :class="getClass(dashboardLayoutCard.dashboardCardTypeCode, dashboardLayoutCard.sequenceNumber)">
    <div class="dashboard-header">
      <div class="dashboard-title">
        <div class="dashboard-title-details">
          <a href="/analytics/explore" @click="$parent.logViewDetailsEvent(title)">            
            Metric <br/> Trends
          </a>
          <smart-center-link v-if="displayDashboard" page="Competitive Dashboard" location="Metric Trends" />
          <span class="ml-2"><modal-link :modal-id="title" :content-list="pageContentForDashboard"></modal-link></span>
        </div>
        <div class="dashboard-save-dashboard-card"  @click="$modal.show(modalName)"> 
            Save for Report
            <span class="m-1">
              <font-awesome-icon :icon="['fa', 'floppy-disk']" />
            </span>
        </div>
      </div>
      <div class="dashboard-widgets dashboard-metric-trends">
        <div class="dashboard-card-dropdown">        
          <div class="control-label">Company</div>
          <multiselect
            ref="stickByOptionSelect"
            :disabled="readOnly"
            v-model="values"
            :options="by_competitor_options"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :max-height="250"
            select-label=""
            deselect-label=""
            selected-label=""
            placeholder="Select Checkboxes"
            label="name"
            :max="maximumCompanyOptions"
            name="multi-stick-by-option"
            track-by="value"
            :preselect-first="false"
            @close="updateCard"
            @select="addCompanyOption"
            @remove="removeCompanyOption"
          >
            <template slot="maxElements">
              <span style="color: #e54d42">{{ maximumCompanyOptionMessage }}</span><a href="#" @click="clearSelections">Click here to clear selections</a>
            </template>
            <template #selection="{ values, isOpen }">
              <span class="multiselect__single"
                    v-if="values.length >= 1"
                    v-show="!isOpen">{{ values.length }} selected <a style="float:right" v-if="values.length >= 3" href="#" @click="clearSelections">Clear</a></span>
            </template>            
            <template #option="props">
              <span class="checkbox-label"  @click.self="select(props.option)">
                <input name="multi-stick-by-option" class="mr-1" type="checkbox" v-model="props.option.checked" @focus.prevent />
                {{ props.option.name }}
              </span>
            </template>
          </multiselect>
        </div>
        <dashboard-card-dropdown label="Metric" :read-only="readOnly" :options="inputMetricOptions" :default-value="metricId" @change="saveMetric" :display-default-dropdown-option="!inputMetricOptions || inputMetricOptions.length === 0"></dashboard-card-dropdown>
      </div>
      <dashboard-card-expand :dashboard-id="dashboardId" />
    </div>
    <div class="dashboard-divider"></div>
    <div class="dashboard-card-body">
      <dashboard-card-skeleton v-if="!displayDashboard" />
      <div class="metric-trends-dashboard-chart" :style="dashboardChartStyle" v-show="inputMetricOptions.length > 0">
        <chart :options="options"></chart>
      </div>
      <div id="metric-trends-mini">
        <img :src="imageUrl" class="pdf-content-image-width hidden-dashboard-display"/>
      </div>
      <div v-if="this.noData == true && this.displayDashboard == true" class="no-data-for-chart-container" style="height: 250px;">
          <div v-show="inputMetricOptions.length == 0" class="no-data-for-chart mx-auto">
            <div class="pb-2">Not enough data in your selection</div>
            <div class="pb-2">exists to build a digital profile.</div>
            <div class="pb-2">Try selecting a map card,</div>
            <div class="pb-2">and metric.</div>
          </div>
      </div>
    </div>
    <dashboard-modal 
      :modal-id="dashboardId" 
      :chart="this.chart" 
      :client-chart="this.clientChart" 
      :dashboard-card-report-page-type-name="reportTypeName" 
      :modal-title="title" 
      :modal-chart-options="options" />
    <vue-modal :ref="modalName" :name="modalName" :width="350" :height="200">
      <save-chart :modal-name="modalName" button-label="Save for Report" :chart-title="this.chartTitle" :initial-client-chart="this.clientChart" @save="this.updateClientCharts" @closeModal="closeModal(this.modalName)"></save-chart>
    </vue-modal>
  </div>
</template>

<script>
import DashboardMixins from "../../mixins/DashboardMixins.vue";
import DashboardService from "../../services/dashboard.service";
import AdminService from "../../services/admin.service";
import ClientCompetitorService from "../../services/client.competitor.service";
import ClientService from "../../services/client.service";  
import MetricsService from "../../services/metrics.service";

import Multiselect from "vue-multiselect";
import $ from "jquery";
import { markRaw } from 'vue'; 

import SaveChart from "../chart/SaveChart.vue";
import DashboardCardDropdown from "./DashboardCardDropdown";
import DashboardCardSkeleton from "../../components/skeleton/DashboardCardSkeleton.vue";
import "echarts/lib/chart/heatmap";
import * as echarts from "echarts";

export default {
  name: "DashboardMetricTrends",
  mixins: [DashboardMixins],
  components: { SaveChart,DashboardCardSkeleton,DashboardCardDropdown,Multiselect },
  data() {
    return {
      
      title: "Metric Trends",
      modalName: "metric-trends-save-chart-confirmation",     

      initialCompetitorsLoaded: false,      
      by_competitor_options: [],
      values: [],
      companies: [],
      metricId: "",
      useMetricGrowth: false,
      disableWidget: false,
      noData: true,
      usePercentage: true,
      metricDisplayTypeName: "",       
      metricsSeries: {
        name: "Metric",
        type: "line",
        smooth: false,
        showAllSymbol: true,
        symbol: "none",
        step: "",
        lineStyle: { width: 4 }, 
        z: 14,
        data: [],
        itemStyle: {
          color: "#2F5EB3"
        }
      },
    };
  },
  props: {
    inputMetricOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },    
    inputMetricId: {
      type: String,
      default: ""
    },
    entryClientChart: {
      type: Object,
      default: function () {
        return {};
      },
    },
    inputClientCharts: {
      type: Array,
      default: function() {
        return [];
      }
    },
    maximumCompanyOptions: {
      type: Number,
      default: 3
    }, 
    inputSaveSettings: {
      type: Boolean,
      default: false
    },     
  },
  computed: {
    showCompetitorsDropdown: function(){
      return this.by_competitor_options.length > 0;
    },    
    maximumCompanyOptionMessage: function() {
      return "Maximum of " + this.maximumCompanyOptions + " options. Clear your selections and chose again.";
    },     
  },
  mounted() {
    this.displayDashboard = true;
    this.setChartDetails();
    this.metricId = this.inputMetricId;
  },
  created() {},
  methods: {
    initialLoadData: async function() {
      // eslint-disable-next-line no-console
      //console.log("DashboardMetricTrends::initialLoadData this.autoGenerateChartRun: " + this.autoGenerateChartRun + "  client id: " + this.entryClientChart.clientId + "  time period id: " + this.timePeriodId);
      this.setChartDetails();
      this.clearData();
      this.startTimePeriodId = this.timePeriodId;

      let clientId = (typeof this.entryClientChart !== "undefined" && typeof this.entryClientChart.clientId !== "undefined") ? this.entryClientChart.clientId : this.$parent.$parent.clientId;
      if(this.startTimePeriodId != "") {
        await ClientCompetitorService.getCompetitors(clientId, Number(this.startTimePeriodId), false, this.loadCompetitors, true);
        this.initialCompetitorsLoaded = true;
      }

      if (this.autoGenerateChartRun){
          this.initialCompetitorsLoaded = true;
          this.processAutoGenerateChart();
      } else {
        this.setCompanies();
        this.displayDashboard = true; 
      }
      this.updateCard();
    },
    loadData: function() {},
    setChartDetails(){
      this.chartTitle = "Metric Trends";
      this.chartTypeName = "dashboard-metric-trends";
      this.containerId = "metric-trends-mini";
      this.reportTypeName = "Dashboard - Metric Trends";
      this.modalName = "metric-trends-save-chart-confirmation";
    },
    addCompanyOption(selectedOption) {
      selectedOption.checked = true;
    },  
    removeCompanyOption(selectedOption) {
      selectedOption.checked = false;
    },
    updateCard: function() {
      this.resetChart();
      if (!this.inputMetricOptions || this.inputMetricOptions.length == 0) {
        this.metricId = "";
      }
      if (this.initialCompetitorsLoaded == true){
        this.displayDashboard = false;
        let vm = this;
        setTimeout(function() {
          if (!vm.autoGenerateChartRun){
            vm.metricId = DashboardService.getDashboardSetting(vm.$parent.defaultDashboardValues, DashboardService.DASHBOARD_METRIC_TRENDS_METRIC, vm.inputMetricId, vm.inputMetricOptions);
          }
          if (typeof vm.metricId != "undefined" && vm.metricId.includes("growth")) {
            vm.useMetricGrowth = true;
          }
          if (typeof vm.metricId == "undefined" || vm.metricId == "") {
            let userSavedMetricId = DashboardService.getDashboardSetting(vm.$parent.defaultDashboardValues, DashboardService.DASHBOARD_METRIC_TRENDS_METRIC, vm.inputMetricId, vm.inputMetricOptions);
            if (typeof userSavedMetricId != "undefined" && userSavedMetricId != "") {
              vm.metricId = userSavedMetricId;
            } else if (vm.inputMetricOptions && vm.inputMetricOptions.length > 0) {
              MetricsService.setMetricDropdownOptions(vm.inputMetricOptions,vm);
            }
          }
          if (vm.startTimePeriodId != "" && vm.metricId != "") {
            vm.displayDashboard = false;
            this.disableWidget = true;
            vm.companies = vm.values.map(x => x.value); 
            if (!vm.autoGenerateChartRun){            
              let companies = vm.companies.join(",");
              DashboardService.setDashboardSetting(vm.$parent.defaultDashboardValues, DashboardService.DASHBOARD_METRIC_TRENDS_COMPANIES, companies);
            }
            if ((typeof vm.metricId != "undefined" && vm.metricId.includes("growth"))) {
              vm.useMetricGrowth = true;
            }
            DashboardService.getMetricTrends(vm.startTimePeriodId, vm.companies, vm.metricId, vm.useMetricGrowth, vm.startTimePeriodId, vm.inputSaveSettings, vm.getMetricTrendsCallback, vm);
          } else {
            vm.displayDashboard = true;
            vm.noData = true;
          }
        }, 1000);
      }
    },
    getMetricTrendsCallback(response) {
      this.disableWidget = false;
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        if (!this.autoGenerateChartRun){
          this.setupClientChart();
        } 
        let returnData = response.data.data;    
        this.noData = returnData.noData;
        this.displayDashboard = true;
        this.metricDisplayTypeName = response.data.data.metricDisplayTypeName;
        this.usePercentage = response.data.data.usePercentage;

        let dynamicOptions = returnData.options;
        this.initChart(dynamicOptions);

        if (this.autoGenerateChartRun && !this.readOnly){
          this.minDashboardChartHeight = 0;
        }
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    initChart(dynamicOptions) {
      //  https://echarts.apache.org/examples/en/editor.html?c=pictorialBar-dotted
      let chartDiv = $(".metric-trends-dashboard-chart")[0];
      this.chart = markRaw(echarts.init(chartDiv));
      let vm = this;
      this.chart.on('finished', () => {
        vm.saveImage();
      });
      this.options = DashboardService.getMetricTrendsOptions(echarts, ClientService.getClientColor());      
      if (dynamicOptions.series != null && dynamicOptions.series != undefined) {
        for (let i = 0; i < dynamicOptions.series.length; i++) {
          DashboardService.setIndividualSeries(this.metricsSeries, i, dynamicOptions);
        }
      } 
      this.options.legend.data = DashboardService.setLegend(this.options.legend.data, dynamicOptions);
      $.extend(true, this.options, dynamicOptions);
      let yAxisLabel = DashboardService.getMetricFormatter(this.metricDisplayTypeName, this.usePercentage);
      $.extend(true, this.options.yAxis[0].axisLabel, yAxisLabel);
      this.options.yAxis[0].min = null;
      let yAxisMax  = {
        max: function (value) {
          return value.max + 1;
        }
      };
      $.extend(true, this.options.yAxis[0].max, yAxisMax);    
      let splitLine = {
        show: true,
        lineStyle: {
          color: "#C8C8C8",
          width: 0.25
        }      
      };
      $.extend(true, this.options.yAxis[0].splitLine, splitLine);  
      //this.printOptions();
      this.chart.setOption(this.options, true);      
    },    
    loadCompetitors(data) {
      this.by_competitor_options = [];
      for (var i = 0; i < data.length; i++) {
        this.by_competitor_options.push({ value: data[i].companyId, name: data[i].name });
      }
    },    
    clearData() {
      this.noData = true;
      this.displayDashboard = false;
      this.values = [];
      this.companies = [];
      this.metricId = "";
    },
    processSavedChartCriteria(criteria) {
        let criteriaParameters = criteria.split("=");
        let isCompanies = criteriaParameters[0] == "companies" ? true : false;
        if (isCompanies) {
            let companies = "";
            try {
                companies = JSON.parse(criteriaParameters[1]);
            } catch (e) {
                companies = decodeURIComponent(criteriaParameters[1]).replace(/\+/g, " ");
            }
            this.setValues(companies);
        }
        let isMetric = criteriaParameters[0] == "metric" ? true : false;
        if (isMetric) {
            this.metricId = criteriaParameters[1];
        }
        let isUseMetricGrowth = criteriaParameters[0] == "useMetricGrowth" ? true : false;
        if (isUseMetricGrowth) {
            this.useMetricGrowth = criteriaParameters[1];
        }
        let isStartTimePeriodId = criteriaParameters[0] == "timePeriodId" ? true : false;
        if (isStartTimePeriodId) {
            this.startTimePeriodId = criteriaParameters[1];
        }
    },    
    buildUrlParams(client_id) {
      let params = this.buildBaseUrlParams();
      params.append("companies",this.companies);
      params.append("metric",this.metricId);
      params.append("useMetricGrowth",this.useMetricGrowth);
      params.append("startTimePeriodId",this.startTimePeriodId);      
      return params;
    },  
    setCompanies() {
      let userSettingValue = "";
      let defaultDashboardUserSetting = this.$parent.defaultDashboardValues.find(x => x.userSettingTypeName == DashboardService.DASHBOARD_METRIC_TRENDS_COMPANIES);      
      if (typeof defaultDashboardUserSetting != "undefined") {
        userSettingValue = defaultDashboardUserSetting.userSettingValue;
        this.setValues(userSettingValue);
      }
    },   
    getCompanies() {
      let savedCompetitorsUserSetting = DashboardService.getDashboardSetting(this.$parent.defaultDashboardValues, DashboardService.DASHBOARD_METRIC_TRENDS_COMPANIES, "", this.companies);
      if (typeof savedCompetitorsUserSetting != "undefined" && savedCompetitorsUserSetting != "") {
        this.setValues(savedCompetitorsUserSetting);
      }
    },
    setValues(value){
      this.values = [];
      this.companies = [];
      if (typeof value === 'string' && value.includes(',')) {
        this.companies = value.split(",");
      } else {
        if (this.companies.includes(value) == false){
          this.companies.push(value);
        }
      }
      if (typeof value === 'string' && value.includes('|')) {
        this.companies = value.split("|");
      } else {
        if (this.companies.includes(value) == false && isNaN(value) == false){
          this.companies.push(value);
        }
      }
      this.companies = this.companies.map(Number);
      for (var i = 0; i < this.by_competitor_options.length; i++) {
        for (var companyIndex = 0; companyIndex < this.companies.length; companyIndex++) {
          if (this.by_competitor_options[i].value == this.companies[companyIndex]) {
            this.by_competitor_options[i].checked = true;
            this.values.push(this.by_competitor_options[i]);
            break;
          } else {
            this.by_competitor_options[i].checked = false;
          }
        }  
      }
    },
    saveMetric: function(value) {
      this.metricId = value;
      this.useMetricGrowth = false;
      DashboardService.setDashboardSetting(this.$parent.defaultDashboardValues, DashboardService.DASHBOARD_METRIC_TRENDS_METRIC, this.metricId);
      this.updateCard();
    },
    getMetricGroup: function() {
      let savedId = DashboardService.getDashboardSetting(this.$parent.defaultDashboardValues, DashboardService.DASHBOARD_METRIC_TRENDS_METRIC, this.inputMetricId, this.inputMetricOptions);
      this.metricId = (savedId == "") ? this.inputMetricId : savedId;
    },
    clearSelections() {
      //console.log("DashboardMetricTrends::clearSelections");
      for (var i = 0; i < this.values.length; i++) {
        this.values[i].checked = false;
      }
      this.values = [];
      this.updateCard();
    },
  },
  watch: {
    timePeriodId: function(value) {
      this.startTimePeriodId = value;
      this.initialLoadData();
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>